import store from './store';

export const getProjectProfileDialog = store.get('dialogs.projectProfile');

export const getFilters = store.get('filters');

export const getSelectedFilterId = store.get('selectedFilterId');
